import { useDeleteLetterStore } from '@lib/store';
import { Button, Modal } from '@shared/widgets';

interface DeleteLetterModalProps {
  isOpen: boolean;
  onClose: () => void;
  letterId: string;
}

export const DeleteLetterModal = (props: DeleteLetterModalProps) => {
  const { loading, deleteLetter } = useDeleteLetterStore();

  const deleteHandler = async () => {
    await deleteLetter(props.letterId);
    props.onClose();
  };

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} title='Delete Permanently'>
      <p className='max-md:text-[#4c4c4c80]'>Please confirm that you want to permanently delete this letter.</p>
      <div className='mt-4 mb-8 max-md:mx-6 max-md:mt-4 max-md:rounded-lg max-md:bg-[#d7c29a1a] max-md:p-2'>
        <p className='text-black'>24-hour phone support:</p>
        <p className='text-black'>+44-203-151-7000 / +800-800-00-700</p>
      </div>
      <div className='flex gap-4'>
        <Button fullWidth color='outlined' disabled={loading} onClick={props.onClose}>
          Cancel
        </Button>
        <Button fullWidth isLoading={loading} onClick={deleteHandler}>
          Yes, Delete
        </Button>
      </div>
    </Modal>
  );
};
